module.exports = __webpack_public_path__ + "assets/img/Logitech-for-Creators 3-w540.70687354.jpg";